import { Series } from '@goldcast/api/backend';

import { FilterBy, SortBy, State } from './types';

const mutations = {
  setFilterBy(state: State, filterBy: FilterBy) {
    state.filterBy = filterBy;
  },
  setSortBy(state: State, sortBy: SortBy) {
    state.sortBy = sortBy;
  },
  setCurrentPage(state: State, currentPage: number) {
    state.currentPage = currentPage;
  },
  setSeriesCount(state: State, seriesCount: number) {
    state.seriesCount = seriesCount;
  },
  setSearchTerm(state: State, newSearchTerm: string) {
    state.searchTerm = newSearchTerm;
  },
  setSeriesList(state: State, seriesList: Series[]) {
    state.seriesList = seriesList?.reduce((result, series) => {
      result[series.id] = { ...series };
      return result;
    }, {});
  },
  updateCurrentSeries(state: State, { seriesId, series }: { seriesId: string; series: Series }) {
    const currentSeries = state.seriesList[seriesId];
    state.seriesList[seriesId] = { ...currentSeries, ...series };
  },
  addSeriesToSeriesList(state: State, series: Series) {
    state.seriesList = {
      ...state.seriesList,
      [series.id]: series
    };
  },
  resetSeriesListState(state: State) {
    state.currentPage = 1;
    state.searchTerm = '';
    state.sortBy = 2;
    state.filterBy = 0;
  },
  toggleSelectedTagId(state: State, tagId: string) {
    if (state.selectedTagIds?.includes(tagId)) {
      state.selectedTagIds = state.selectedTagIds.filter(id => id !== tagId);
    } else {
      state.selectedTagIds = [...(state.selectedTagIds || []), tagId];
    }
  },
  clearSelectedTagIds(state: State) {
    state.selectedTagIds = [];
  }
};

export default mutations;
